import { formatarMoeda } from '@/shared/utils/numeros';
import { SimuladorFolhaDetalhe, SimuladorFolhaResumo } from '../simulador-folha.types';

interface Props {
  dados: SimuladorFolhaDetalhe[];
  resumo?: SimuladorFolhaResumo;
  tableId?: string;
}

export function TabelaDetalhes({ dados, resumo, tableId = 'tabela-simulador-detalhes' }: Props) {
  const totais = resumo ?? {
    quantidadeServidores: dados.length,
    totalAtual: dados.reduce((acc, item) => acc + item.valorAtual, 0),
    totalProjetado: dados.reduce((acc, item) => acc + item.valorProjetado, 0),
    diferenca: dados.reduce((acc, item) => acc + item.diferenca, 0),
  };

  return (
    <div className="table-responsive">
      <table id={tableId} className="table table-sm table-bordered table-striped">
        <thead>
          <tr>
            <th>Nome</th>
            <th>Tipo</th>
            <th>Função</th>
            <th>Local</th>
            <th className="text-end">Atual</th>
            <th className="text-end">Projetado</th>
            <th className="text-end">Diferença</th>
          </tr>
        </thead>
        <tbody>
          {dados.map((item) => (
            <tr key={`${item.tipo}-${item.pessoaId}`}>
              <td>{item.nome}</td>
              <td>{item.tipo === 'defensor' ? 'Defensor' : 'Colaborador'}</td>
              <td>{item.funcaoNome}</td>
              <td>{item.localNome}</td>
              <td className="text-end">{formatarMoeda(item.valorAtual)}</td>
              <td className="text-end">{formatarMoeda(item.valorProjetado)}</td>
              <td className="text-end">{formatarMoeda(item.diferenca)}</td>
            </tr>
          ))}
        </tbody>
        <tfoot className="table-secondary fw-semibold">
          <tr>
            <td colSpan={4}>Total ({totais.quantidadeServidores} servidor{totais.quantidadeServidores !== 1 ? 'es' : ''})</td>
            <td className="text-end">{formatarMoeda(totais.totalAtual)}</td>
            <td className="text-end">{formatarMoeda(totais.totalProjetado)}</td>
            <td className="text-end">{formatarMoeda(totais.diferenca)}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
}
